import { useState, useEffect, useRef } from 'react'

import { Container, Row, Col, Navbar, Nav, Button } from 'react-bootstrap';
import { BarChart3, Camera, Code, Code2, Fingerprint, Funnel, GraduationCap, Heart, Map, Palette, Radar, Share2, Video, Videotape, Mail, MessageCircle, Globe, Instagram, Linkedin, UserCircle, Facebook, ArrowRight, Hand, FacebookIcon } from 'lucide-react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import logo from './img/eurekalogo.png'
import hamburguer from './img/hamburguer.png'
import _3_ from './img/3.png'
import gratis from './img/gratis.png'
import aniversario from './img/aniversario.png'
import BrutalistForm from './BrutalistForm';

const App = () => {
  return (
    <div className="hero-brutalist">
      <Container className="h-100 position-relative">
        <Row>
          <div align="center">
            <div className='mt-4 mb-4'>
              <img src={logo} className='logo' />
            </div>
            {/*div>
              <FacebookIcon size={18} /> &nbsp;&nbsp;
              <Instagram size={18} />
            </div>*/}
          </div>
        </Row>
        <Row>
          <Col>
            <div className="title-container-brutalist mb-5 text-center">
              <div className="main-headline-outline">
                ¡Celebra con nosotros nuestro
              </div>
              {/*<div className="text-gradient reveal-text delay-2 fw-bold mb-4"
                style={{ lineHeight: '1.1' }}>
                8VO ANIVERSARIO!
              </div>*/}
              <div className="main-headline-fill">
                8VO ANIVERSARIO!
              </div>
            </div>
          </Col>
        </Row>
        <Row className="align-items-center h-100">
          <Col lg={5} className="text-content z-2 p-0 m-0">
            {/*<Row>
              <div className='mb-4'>
                <img src={aniversario} className='img-hamburguer' />
              </div>
            </Row>*/}

            <div className="title mt-5" align="left">
              <div>Participa y gana una de nuestras...</div><br />
            </div>

            <Row className='align-items-center'>
              <Col md={6}>
                <div>
                  <img src={_3_} className='img-hamburguer' />
                </div>
              </Col>
              <Col md={6}>
                <div>
                  <img src={gratis} className='img-hamburguer' />
                </div>
              </Col>
            </Row>

            <div className="title mt-5">
              <div>¡No dejes pasar la oportunidad y registrate!</div><br />
            </div>

            <BrutalistForm />
          </Col>

          <Col lg={7} className="position-relative d-none d-lg-block p-0 m-0">
            <img src={hamburguer} className="img-hamburguer" alt="Foto" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default App;
